<template>
    <div>
      <div class="row">
        <div class="col-6">
          <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="Beta diversity (β-diversity) is the ratio between regional and local species diversity."
             v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i>
        </div>
        <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
          <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
             v-bind:style="{ fontSize : '15px'}"></i>
          <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
          <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
             v-b-modal="componentId+'-modal-save'"></i>
          <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
             v-bind:style="{ fontSize : '12px'}"></i>
        </div>
      </div>
        <div class="widget-legend legend">
      <span :id="componentId+'plot_title'">Beta diversity using Bray Curtis dissimilarity on fraction {{
          fraction
          }} µm µm correlated with {{ parameter.text }} </span>
        </div>
        <BetaDiversityDissimilarityWidget :colorParameter="colorBy" :plotData="plotData" :axisLabel="axisLabel"
                                       :componentId="componentId" :pcPlotData="pcPlotData">
        </BetaDiversityDissimilarityWidget>

        <div class="align-content-center" v-if="plotData">
            Stress : {{ this.plotData.stress }}
        </div>
        <div>
            <b-modal :id="componentId+'-modal'" title="Bray Curtis parameter">
                <div class="form-group mt-2" style="font-size: 1.6vmin;">
                    <div class="form-group mt-2" style="font-size: 1.6vmin;">
                        <template>
                            <b-form-group label="Dissimilarity Type" v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                        :id="componentId+'radio-group-dissimilarityType'"
                                        v-model="dissimilarityType"
                                        :options="dissimilarityTypes"
                                        :aria-describedby="ariaDescribedby"
                                        name="dissimilarity-options"
                                ></b-form-radio-group>
                            </b-form-group>
                        </template>
                    </div>
                    <b-form-group label="Parameter">
                        <select v-model="parameter" class="form-control">
                            <option v-for="option in parameters" v-bind:key="option.value" :value="option">
                                {{ option.text }}
                            </option>
                        </select>
                    </b-form-group>
                    <div class="form-group mt-2" style="font-size: 1.6vmin;">
                        <template>
                            <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                        :id="componentId+'radio-group-2'"
                                        v-model="fraction"
                                        :options="fractions"
                                        :aria-describedby="ariaDescribedby"
                                        name="fraction-options"
                                ></b-form-radio-group>
                            </b-form-group>
                        </template>
                    </div>
                    <div class="form-group mt-2" style="font-size: 1.6vmin;">
                        <b-form-group label="Color by">
                            <select v-model="colorBy" class="form-control">
                                <option v-for="option in colorOptions" v-bind:key="option.value" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                        </b-form-group>
                    </div>
                </div>
            </b-modal>
        </div>
        <b-modal :id="componentId+'-legend'" title="Legend">
            HTML allowed
            <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

            <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
        </b-modal>
        <ExportDialog :componentId="componentId" :labels="null" :formattedData="formattedData" :plotData="plotData"
                      :exportFileName="exportFileName" :dataset="dataset" :legend="legend"></ExportDialog>
        <div>
            <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
                <b-card>
                    <div v-html="legend">
                    </div>

                </b-card>
            </b-collapse>
        </div>

    </div>
</template>


<script>
/* eslint-disable vue/no-dupe-keys */
import axios from "axios";
import {mapActions} from "vuex";
import BetaDiversityDissimilarityWidget from "./BetaDiversityDissimilarityWidget";
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";


export default {
    name: "BrayCurtisDissimilarity",
    props: ['panelId', 'componentId', 'triggerValue', 'settings'],
    mixins: [ApiCall],
    data() {
        return {
            dataset: null,
            dissimilarityTypes: [{text: 'Bray-Curtis', value: "bray_curtis"}, {text: 'Jaccard', value: "jaccard"}],
            dissimilarityType: null,

            rank: null,
            searchPanelTaxon: null,

            dateStart: null,
            dateEnd: null,
            legend: null,
            taxon: null,
            taxons: {},
            asv: [],
            asvs: {},
            visible:false,
            parameters: [],
            parameter: {},

            fractions: [],
            fraction: [],
            formattedData: null,
            axisLabel: "",
            plotData: null,
            pcPlotData: null,
            settingsHash: "",
            parameterHash: "",
            exportFileName: "mygod_beta_diversity",
            apiCallInProgress: 0,
            colorBy: null,
            colorOptions: [{"value": "depth", "text": "Depth"},
                {"value": "station", "text": "Stations"}, {
                    "value": "min_frac_size",
                    "text": "Fraction Size"
                }, {"value": "season", "text": "Season"}]
        }

    },
    components: {
        BetaDiversityDissimilarityWidget,
        ExportDialog
    },

    created() {
        this.updateContents()
    },

    watch: {

        trigger_value() {
            this.updateContents()
        },

        taxon() {
            this.getPlotData()
        },

        fraction() {
            this.getPlotData()
        },
        parameter() {
            this.getPlotData()
        },
        colorBy() {
            this.updateSavedSettings()
        },
        dissimilarityType() {
            this.getPlotData()
        },
        legend() {
            this.updateDashboardWidgetLegend({
                'componentId': this.componentId,
                'legend': this.legend
            })
        },
        plotData() {
            this.formattedData = this.plotData.data
        }

    },

    methods: {

        ...mapActions([
            'updateDashboardWidgetSettings',
            'cloneWidget',
            'updateDashboardWidgetLegend'
        ]),

        updateContents() {
            let panel = this.$store.state.panels[this.panelId]

            let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
            if (newPanelSettingsHash === this.settingsPanelHash) {
                return
            }
            this.settingsPanelHash = newPanelSettingsHash
            this.plotData = null

            this.dataset = panel.dataset
            this.rank = panel.rank
            this.searchPanelTaxon = panel.taxon
            this.dateStart = panel.dateStart
            this.dateEnd = panel.dateEnd

            this.initializeColorBy()
            this.initializeLegend()
            this.initializeDissimilarityType()
            this.initializeParameters()
            this.initializeFractionSizes()
        },

        cloneCurrentWidget() {
            this.cloneWidget({'componentId': this.componentId})
        },

        updateSavedSettings() {
            this.updateDashboardWidgetSettings({
                'componentId': this.componentId,
                'settings': {
                    'dataset': this.dataset,
                    'taxon': this.searchPanelTaxon,
                    "rank": this.rank,
                    'fraction': this.fraction,
                    'dateStart': this.dateStart,
                    'dateEnd': this.dateEnd,
                    'colorBy': this.colorBy,
                    'parameter': this.parameter,
                    'legend': this.legend,
                    'dissimilarityType': this.dissimilarityType
                }
            })
        },

        getPlotData() {
            if (this.apiCallInProgress > 0) {
                setTimeout(this.getPlotData, 2000)
                return
            }
            if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.searchPanelTaxon + this.rank + this.dissimilarityType + this.parameter) {
                let newSettingsHash = this.dataset + this.searchPanelTaxon + this.rank + this.fraction + this.dateStart + this.dateEnd + this.dissimilarityType

                let me = this
                let newParameter = this.parameter['value']
                if (newParameter !== this.parameterHash) {
                    axios
                        .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['physico_chemical_beta_diversity',
                        this.dataset, this.dateStart, this.dateEnd, this.parameter['value']]))
                        .then(function (response) {
                            me.pcPlotData = response.data
                        })
                    this.parameterHash = newParameter

                }

                if (newSettingsHash !== this.settingsHash) {


                    this.settingsHash = newSettingsHash
                    this.updateSavedSettings()

                    let me = this
                    let fractions_list = JSON.stringify(this.fraction)
                    this.plotData = null

                    axios
                        .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['beta_diversity_dissimilarity',
                        this.dataset, this.rank, this.searchPanelTaxon, fractions_list, this.dateStart, this.dateEnd,
                        this.dissimilarityType]))
                        .then(function (response) {
                            me.plotData = response.data
                        })
                } else {
                    console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
                }
            }

        },

        initializeColorBy() {
            let me = this
            if (me.settings['restore']) {
                me.colorBy = me.settings['colorBy']
            } else {
                me.colorBy = "min_frac_size"
            }
        },

        initializeDissimilarityType() {
            let me = this
            if (me.settings['restore']) {
                me.dissimilarityType = me.settings['dissimilarityType']
            } else {
                me.dissimilarityType = "bray_curtis"
            }
        },

    }
}


</script>

<style scoped>
.radio-button-font {
    font-size: large;
}

</style>